import { Routes } from "@angular/router";

export const PlanningRoutes: Routes = [
	{
		path: "",
		loadComponent: () =>
			import(
				"@/app/domains/erp/planning/pages/planning-container/planning-container.page"
			).then((m) => m.PlanningContainerPage),
	},
	{
		path: "planning-edit",
		loadComponent: () =>
			import("@/app/domains/erp/planning/pages/planning-edit/planning-edit.page").then(
				(m) => m.PlanningEditPage
			),
	},
	{
		path: "manufacturing-container",
		children: [
			{
				path: "",
				loadComponent: () =>
					import(
						"../pages/manufacturing-module/manufacturing-container/manufacturing-container.page"
					).then((m) => m.ManufacturingContainerPage),
			},
			{
				path: "manufacturing-edit",
				children: [
					{
						path: "",
						loadComponent: () =>
							import(
								"../pages/manufacturing-module/manufacturing-edit/manufacturing-edit.page"
							).then((m) => m.ManufacturingEditPage),
					},
					{
						path: "transfer-edit",
						loadComponent: () =>
							import(
								'@/app/domains/erp/transfers/pages/transfer-edit/transfer-edit.page'
							).then((m) => m.TransferEditPage),
					},
					{
						path: "manufacturing-edit",
						children: [
							{
								path: "",
								loadComponent: () =>
									import(
										"../pages/manufacturing-module/manufacturing-edit/manufacturing-edit.page"
									).then((m) => m.ManufacturingEditPage),
							},
							{
								path: "transfer-edit",
								loadComponent: () =>
									import(
										'@/app/domains/erp/transfers/pages/transfer-edit/transfer-edit.page'
									).then((m) => m.TransferEditPage),
							},
							{
								path: "manufacturing-edit",
								children: [
									{
										path: "",
										loadComponent: () =>
											import(
												"../pages/manufacturing-module/manufacturing-edit/manufacturing-edit.page"
											).then((m) => m.ManufacturingEditPage),
									},
									{
										path: "manufacturing-edit",
										loadComponent: () =>
											import(
												"../pages/manufacturing-module/manufacturing-edit/manufacturing-edit.page"
											).then((m) => m.ManufacturingEditPage),
									},
									{
										path: "transfer-edit",
										loadComponent: () =>
											import(
												'@/app/domains/erp/transfers/pages/transfer-edit/transfer-edit.page'
											).then((m) => m.TransferEditPage),
									},
								],
							},
						],
					},
					{
						path: "transfer-edit",
						loadComponent: () =>
							import(
								'@/app/domains/erp/transfers/pages/transfer-edit/transfer-edit.page'
							).then((m) => m.TransferEditPage),
					},
				],
			},
		],
	},
	{
		path: "**",
		redirectTo: "",
		pathMatch: "full",
	},
];
